import { Box, Grid, LinearProgress, Stack, Typography } from '@mui/material'
import ButtonCustom from '../atoms/button/ButtonCustom'
import SelectCustom from '../atoms/select/SelectCustom'

import styles from './budgetTrackerStyle.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { closeModal, openModal } from '../../features/commonSlice'
import CommonModal from '../atoms/modal/CommonModal'
import InputCustom from '../atoms/input/InputCustom'
import { useState, useEffect } from 'react'
import { toastHelper } from '../../util/toastHelper'
import { useParams } from 'react-router-dom'
import { updateKazooBudget } from '../../features/kazooEventSlice'

const region_options = [
	{ value: 'oliver hansen', label: 'Oliver Hansen' },
	{ value: 'van henry', label: 'Van Henry' },
	{ value: 'april tucker', label: 'April Tucker' },
	{ value: 'ralph hubbard', label: 'Ralph Hubbard' },
	{ value: 'omar alexander', label: 'Omar Alexander' },
]
const TotalBudget = () => {
	const dispatch = useDispatch()
    const { kazooId } = useParams()

	const modal = useSelector((s) => s.common.modal)
	const budget = useSelector((s) => s.kazooEvent.budget)
	const allocatedBudget = useSelector(
		(state) => state.kazooEvent.allocatedBudget
	)
	const percentageOfTotal = useSelector((state) => state.kazooEvent.allocatedPercentage)

    const [data, setData] = useState({})


	const handleClose = () => {
		dispatch(closeModal())
	}

    const handleSaveBudget = (e) => {
        e.preventDefault()
        if(data.budget <= 0){
            return toastHelper('Budget must be above 0', 'error')
        }

        dispatch(updateKazooBudget({kazooId, newBudget: data.budget}))
        dispatch(closeModal())
    }

    useEffect(() => {
        setData({budget})
    }, [budget])

	return (
		<>
			<div className={`${styles.totalBudgetWrp}`}>
				<div className={styles.heading}>
					<Typography variant="h4">Total Budget</Typography>
				</div>

				<div className={styles.totalBudgetAmount}>
					<Typography variant="h5">
						${budget.toLocaleString()}
					</Typography>
					<ButtonCustom
						variant="default"
						size="sm"
						onClick={() => dispatch(openModal('editBudget'))}
					>
						Set Budget
					</ButtonCustom>
				</div>
				<div className={styles.allocatedCol}>
					<Box
						key={5}
						sx={{
							display: 'flex',
							flexDirection: 'column',
							gap: '8px',
						}}
					>
						<div className={styles.allocatedAmount}>
							<Typography variant="h5">Allocated</Typography>
							<Typography variant="h6">
								${allocatedBudget.toLocaleString()}
							</Typography>
						</div>
						<Stack direction="row" alignItems="center" spacing={2}>
							<LinearProgress
								variant={
                                    percentageOfTotal > 100 ? 
                                    "buffer" : "determinate"
                                }
								value={percentageOfTotal}
								sx={{
									flexGrow: 1,
									height: 8,
									borderRadius: 4,
									backgroundColor: '#FAF4F2',
									'& .MuiLinearProgress-bar': {
										backgroundColor: 
                                            percentageOfTotal >= 80 ? 
                                                (percentageOfTotal >= 100 ?
                                                    'red' : 'orange')
                                            : '#7CA6BD',
										borderRadius: 4,
									},
								}}
							/>
						</Stack>
						<div className={styles.percentUsed}>
							<span>{percentageOfTotal}% used</span>
						</div>
					</Box>
				</div>
				{/* Region not needed right now */}
				{/* <div className={styles.tbItem}>
					<label className={styles.itemLabel}>Region</label>
					<SelectCustom
						label="Select Region"
						options={region_options}
					/>
				</div> */}
				<CommonModal
					open={modal === 'editBudget'}
					handleClose={handleClose}
					heading="Edit Budget"
					footerContent={
						<>
							<ButtonCustom
								variant="outlined"
								onClick={handleClose}
							>
								Cancel
							</ButtonCustom>
							<ButtonCustom onClick={handleSaveBudget}>
								Save
							</ButtonCustom>
						</>
					}
				>
					<form
                        className={styles.formWrp}
                        onSubmit={handleSaveBudget}
                    >
						<Grid container spacing={1.5}>
							<Grid size={{ xs: 12, md: 12 }}>
								<InputCustom
                                    data_cy="totalBudget"
									label="Edit current budget"
									type="number"
									name="budget"
									placeholder="$ CAD"
                                    value={data.budget}
                                    data={data}
                                    setDataFunction={setData}
								/>
							</Grid>
						</Grid>
					</form>
				</CommonModal>
			</div>
		</>
	)
}

export default TotalBudget
